"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomingBatchesTableToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const table_action_button_1 = require("../../../../composite/action-button/table/table-action-button");
const batches_api_1 = require("./batches-api");
function IncomingBatchesTableToolbar({ url }) {
    const intl = (0, react_intl_1.useIntl)();
    const process = (0, react_1.useMemo)(() => (0, batches_api_1.processFactory)(url), [url]);
    const externalizeProcessed = (0, react_1.useMemo)(() => (0, batches_api_1.externalizeProcessedFactory)(url), [url]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_action_button_1.TableActionButton, { promptKey: "INCOMING_BATCHES_PROCESS", apiCall: process, buttonLabel: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_TOOLBAR_BTN_PROCESS',
                defaultMessage: 'Sync',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_TOOLBAR_TOOLTIP_PROCESS',
                defaultMessage: 'Zpracovat',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_PROCESS_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_PROCESS_DIALOG_TEXT',
                defaultMessage: 'Chcete vynutit zpracování všech dávek ze spisové služby ?',
            }) }),
        react_1.default.createElement(table_action_button_1.TableActionButton, { promptKey: "INCOMING_BATCHES_EXTERNALIZE_PROCESSED", apiCall: externalizeProcessed, buttonLabel: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_TOOLBAR_BTN_EXTERNALIZE_PROCESSED',
                defaultMessage: 'E',
            }), buttonTooltip: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_TOOLBAR_TOOLTIP_EXTERNALIZE_PROCESSED',
                defaultMessage: 'Externalizovat zpracované',
            }), dialogTitle: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_EXTERNALIZE_PROCESSED_DIALOG_TITLE',
                defaultMessage: 'Varování',
            }), dialogText: intl.formatMessage({
                id: 'ESS_INCOMING_BATCHES_EXTERNALIZE_PROCESSED_DIALOG_TEXT',
                defaultMessage: 'Chcete vynutit externalizaci všech zpracovaných dávek ?',
            }) })));
}
exports.IncomingBatchesTableToolbar = IncomingBatchesTableToolbar;
//# sourceMappingURL=batches-table-toolbar.js.map